export const CloseModalX = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    fill="none"
    viewBox="0 0 14 15"
  >
    <path
      stroke="#868C98"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m13 1.5-12 12m0-12 12 12"
    />
  </svg>
);
